<!-- キーワードから探す 小カテゴリ -->
<template>
  <li
    class="crly-a-common-search-category-small icon"
    :class="`cd-${category.catSmlCd}`"
    @click="clickSmallCat"
  >
    <div class="crly-a-common-search-category-small__label">
      {{ category.catSmNm }}
    </div>
    <div class="crly-a-common-search-category-small__icon crly-link-icon"></div>
  </li>
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchCategorySmall",
  props: {
    /**
     * 表示する小カテゴリ
     */
    category: {
      type: Object,
      default: () => ({})
    },
    /**
     * 特大カテゴリ
     */
    catType: {
      type: Number,
      required: true
    },
    /**
     * 大カテゴリ
     */
    lrgCat: {
      type: String,
      required: true
    },
    /**
     * 中カテゴリ
     */
    midCat: {
      type: String,
      required: true
    }
  },
  methods: {
    /**
     * 遷移先URLを作成する
     */
    makeUrl(category) {
      let params = [];
      // グルメで中カテゴリが「飲食店」の場合は小カテゴリがジャンル検索になる
      if (this.lrgCat == "113" && this.midCat == "201") {
        params.push(`${this.CONST.SEARCH_PARAMS.TYPE}=${category.catType}`);
        params.push(
          `${this.CONST.SEARCH_PARAMS.LIFE_GNR}=${category.catSmlCd}`
        );
        return this.makeSearchUrl(this.catType, params);
      }
      // STAYで中カテゴリが「国内の宿」の場合、定義済みパラメータで検索
      else if (
        this.catType == this.CONST.CATEGORY_TYPE.TRAVEL &&
        this.midCat == "201"
      ) {
        params.push(category.searchParam);
        return this.makeSearchUrl(this.catType, params);
      }
      //LIFE、グルメの「飲食店」以外、STAYの「国内宿泊」以外の場合
      else {
        params.push(`${this.CONST.SEARCH_PARAMS.TYPE}=${this.catType}`);
      }
      params.push(`${this.CONST.SEARCH_PARAMS.CAT_LRG}=${this.lrgCat}`);
      params.push(`${this.CONST.SEARCH_PARAMS.CAT_MID}=${this.midCat}`);
      params.push(`${this.CONST.SEARCH_PARAMS.CAT_SML}=${category.catSmlCd}`);
      return this.makeSearchUrl(this.catType, params);
    },
    /**
     * 小カテゴリクリックイベント
     */
    clickSmallCat() {
      const url = this.makeUrl(this.category);
      this.windowOpen(url);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/category/small.scss";
</style>
